import { useState } from 'react';
import type { ApiClient } from '../../api/client';
import type { WorkerNode } from '../../types';

/** A separate server presentation flag never enables ordinary management. */
export default function ScopedSelfUpdate({ apiClient, node, reload }: {
  apiClient: ApiClient; node: WorkerNode; reload: () => Promise<void>;
}) {
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState<string | null>(null);
  if (apiClient.mode !== 'tool-browser' || node.browser_self_update_allowed !== true) return null;
  async function queue(drain: boolean) {
    setBusy(true);
    setNotice(null);
    try {
      // Construct the closed browser contract here; never filter a legacy
      // helper payload, claim completion, or start the ordinary history watch.
      await apiClient.post(`/api/executors/nodes/${encodeURIComponent(node.id)}/self-update`, {
        drain_before_update: drain
      });
      setNotice('Self-update queued. Completion and reconnect status are unavailable in this session.');
      await reload();
    } catch {
      setNotice('Self-update unavailable. Refresh to check current authority.');
    } finally {
      setBusy(false);
    }
  }
  return <div className="stack stack--compact" aria-label="Scoped self-update">
    <div className="row row--compact">
      <button type="button" className="secondary compact" disabled={busy} onClick={() => void queue(true)}>Drain update</button>
      <button type="button" className="secondary compact" disabled={busy} onClick={() => void queue(false)}>Force update</button>
    </div>
    {notice && <p className="hint" role="status">{notice}</p>}
  </div>;
}
